import BackButton from "./BackButton";
import SubmitButton from "./SubmitButton";
import { Box, Stack } from "@mui/material";
import { SxProps, Theme } from "@mui/material";

interface FormSubmitContainerProps {
  sx?: SxProps<Theme>;
  onClick?: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  submitButtonText?: string;
  backButtonVariant?: "dark" | "light" | "transparent";
}

const FormSubmitContainer = ({
  onClick,
  disabled,
  isLoading,
  submitButtonText,
  backButtonVariant = "dark",
  sx = { textTransform: "none" },
}: FormSubmitContainerProps) => {
  return (
    <>
      <Box height={16} />
      <Stack direction={"row"} spacing={2}>
        {onClick && (
          <BackButton variant={backButtonVariant} onClick={onClick} />
        )}
        <SubmitButton
          sx={sx}
          fullWidth
          type="submit"
          disabled={disabled}
          isLoading={isLoading}
          buttonText={submitButtonText}
        />
      </Stack>
    </>
  );
};

export default FormSubmitContainer;
